import React, {useState, useEffect} from 'react'
import { useSelector } from "react-redux";
import {Link} from "react-router-dom";
import Axios from "axios";
import withLanguage from "../../HOC/withLanguage";

const BusinessFilter = ({ language }) => {
    const user = useSelector((state) => state.user);
    const [subjects, setSubjects] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const nipt = user?.nipt ? user?.nipt : ''

    // Fetch subjects data
    const fetchSubjects = async () => {
        setIsLoading(true);
        setError(null);
        try {
            const res = await Axios.get(`/api/data/get_employer_declaration`);
            setSubjects(res.data.records || res.data || []);
        } catch (err) {
            console.error('Error fetching subjects:', err);
            setError(language.ErrorMessage);
            setSubjects([]);
        }
        setIsLoading(false);
    };

    useEffect(() => {
        fetchSubjects();
    }, []);

    return (
        <section className="flex-1">
            {/* Filters */}
            <h2 className="text-[20px] mb-6">
                {language.Text1}
            </h2>

            {/* Link */}
            <div className="text-center border-[1.5px] border-red-600 rounded-[10px] p-3 mb-12 mt-12 cursor-pointer hover:bg-red-50">
                <a href="#" className="text-[#DB3222] underline font-semibold">
                    {language.Text2}
                </a>
            </div>

            {/* Subjects List */}
            <div className="mb-8">
                {/*<h3 className="text-lg py-3 text-[#DB3222] font-bold">*/}
                {/*    {subjects.length} {'Subject'}*/}
                {/*</h3>*/}

                {isLoading ? (
                    <p className="text-gray-500">Loading subjects...</p>
                ) : error ? (
                    <p className="text-red-500">{error}</p>
                ) : subjects.length === 0 ? (
                    <p className="text-gray-500">{language.ErrorMessage}</p>
                ) : (
                    <div className="flex flex-col">
                        {subjects.map((subject) => (
                            <Link
                                key={subject.id}
                                to={`/subjekti/${subject.id}`}
                                className="border-[1.5px] border-red-600 rounded-[10px] p-2.5 mb-3 cursor-pointer hover:bg-red-50"
                            >
                                <span className="text-black font-bold">
                                    {subject.employer_name}
                                </span>
                            </Link>
                        ))}
                    </div>
                )}
            </div>

        </section>
    )
}

export default withLanguage(BusinessFilter, "BusinessFilter");